import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Swal from "sweetalert2";
import axios from "axios";
import "./Packages.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLoading } from "../contexts/LoadingContext";
import Loader from "./loader";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

const Packages = ({ onSelectPackage }) => {
  const localPackages = [
    {
      id: 1123,
      title:
        "One-Time Instant Doctor Consultation bundled with FREE Health Insurance",
      location: "Pakistan",
      originalPrice: "Rs. 1500",
      discountedPrice: "Rs. 300 only",
      discount: "80% Off",
      features: [
        { text: "Audio/Video Call to Doctor", isAvailable: true },
        {
          text: "FREE Health insurance up to Rs. 50,000",
          isAvailable: true,
          link: true,
        },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "One-time Payment", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: false },
        { text: "Maintains Full Medical History", isAvailable: false },
      ],
      insurance: true,
    },
    {
      id: 1124,
      title: "(Monthly Plan)",
      description: "(Unlimited Calls)",
      originalPrice: "Rs. 4000",
      discountedPrice: "Rs. 999/- only",
      discount: "75% Off",
      features: [
        { text: "Video Call to Doctor Anytime", isAvailable: true },
        { text: "Maintains Full Medical History", isAvailable: true },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "Monthly Subscription", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: true },
      ],
      recommended: true,
    },
  ];

  const internationalPackages = [
    {
      id: 1126,
      title: "One Time Instant Doctors for Expats",
      originalPrice: "$25 per call",
      discountedPrice: "$10 per call",
      discount: "60% Off",
      features: [
        { text: "Video Call to Doctor", isAvailable: true },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "One-time Payment", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: false },
        { text: "Maintains Full Medical History", isAvailable: false },
      ],
    },
    {
      id: 1125,
      title: "(Monthly Plan)",
      description: "(Unlimited Calls) for Expats",
      originalPrice: "$35 a month",
      discountedPrice: "$14 monthly",
      discount: "60% Off",
      features: [
        { text: "Video Call to Doctor anytime", isAvailable: true },
        { text: "Maintains Full Medical History", isAvailable: true },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "Monthly Subscription", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: true },
      ],
      // recommended: true,
    },
  ];

  const [packages, setPackages] = useState([]);
  const { isLoading, setIsLoading } = useLoading();
  const [currentCity, setCurrentCity] = useState();
  const [loading, setLoading] = useState({});
  const [error, setError] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const getLocationFromIP = async () => {
      setIsLoading(true);
      try {
        // Use an IP geolocation service (ipinfo, ipstack, etc.)
        const response = await axios.get(
          "https://ipinfo.io/json?token=4cc1d3640d989a"
        );

        if (response.data && response.data.country) {
          const country = response.data.country;
          const city = response.data.city;
          setCurrentCity(city);

          if (country === "PK") {
            setPackages(localPackages);
          } else {
            setPackages(internationalPackages);
          }
          setIsLoading(false);
        } else {
          setPackages(internationalPackages);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching IP-based location:", error);
        setPackages(internationalPackages);
      }
    };

    getLocationFromIP();
  }, []);

  const handleConfirmPayment = async (pkg) => {
    const session = JSON.parse(sessionStorage.getItem("user"));
    const profileId = session?.payLoad?.user?.Id;
    const packageId = pkg.id;

    // International package: require login check and pay directly with Stripe
    if (!session?.payLoad?.access_token) {
      Swal.fire({
        icon: "info",
        title: "Login",
        text: "Please login first",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      }).then(() => {
        navigate(`/login/packages`);
        return;
      });
    }
    // Check if local or international package
    if (pkg.location === "Pakistan" || pkg.originalPrice.includes("Rs")) {
      // Local package: go to payment method selection page (no login check)
      if (typeof onSelectPackage === "function") {
        onSelectPackage(pkg);
      } else {
        navigate("/payment-method", { state: { selectedPackage: pkg } });
      }
      return;
    }

    setLoading((prev) => ({ ...prev, [packageId]: true }));
    setError((prev) => ({ ...prev, [packageId]: null }));

    try {
      const response = await axios.get(
        `${API_BASE_URL}/stripe/payment`,
        {
          params: {
            profile_id: profileId,
            package_id: packageId,
          },
        }
      );

      if (response.data.statusCode === 1) {
        const paymentUrl = response.data.payLoad.url;
        if (paymentUrl) {
          window.location.href = paymentUrl;
        } else {
          throw new Error("Payment URL not found.");
        }
      } else {
        throw new Error("Failed to initiate payment.");
      }
    } catch (err) {
      console.error(err);
      setError((prev) => ({ ...prev, [packageId]: err.message }));
    } finally {
      setLoading((prev) => ({ ...prev, [packageId]: false }));
    }
  };

  return (
    <>
      <Navbar />
      <div className="package-page container-fluid">
        <h2 className="page-title pt-3">Our Packages</h2>
        {isLoading ? (
          <Loader type="package" count={2} />
        ) : (
          <div
            className="package-list row flex-row overflow-auto"
            style={{ gap: "24px" }}
          >
            {packages && packages.length > 0 ? (
              packages.map((pkg) => (
                <div
                  key={pkg.id}
                  className="package-card col-md-4 col-sm-12"
                  style={{ minWidth: 320, flex: "0 0 auto" }}
                >
                  {" "}
                  {pkg.recommended && (
                    <div className="recommended-ribbon">Recommended</div>
                  )}
                  {pkg.insurance && (
                    <div className="insurance-ribbon">
                      <span>FREE Health Insurance</span>
                    </div>
                  )}
                  <div className="ribbon">
                    <span>{pkg.discount}</span>
                  </div>
                  <div style={{ height: 370 }}>
                    <div style={{ height: 100 }}>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          marginTop: "30px",
                          fontWeight: 1200,
                          fontSize: "25px",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: 900 }}>
                          WEB
                        </span>
                        <span
                          style={{
                            color: "#3ec3cf",
                            fontWeight: 900,
                            marginLeft: "2px",
                          }}
                        >
                          DOC
                        </span>
                        <span
                          style={{
                            color: "#444",
                            fontWeight: 600,
                            marginLeft: "8px",
                          }}
                        >
                          CARE
                        </span>
                        <span
                          style={{
                            fontWeight: 600,
                            marginLeft: "2px",
                          }}
                        >
                          +
                        </span>
                      </div>
                      <p className="package-title">{pkg.title}</p>
                    </div>

                    <div
                      className="price"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <span
                        className="original-price"
                        style={{
                          color: "#000",
                          fontSize: "1.5rem",
                          fontWeight: 400,
                          position: "relative",
                          zIndex: 1,
                          background: "#fff",
                          padding: "0 8px",
                        }}
                      >
                        {pkg.originalPrice}
                      </span>
                      {/* Red X SVG overlay */}
                      {/* <svg
                      width="60"
                      height="40"
                      viewBox="0 0 90 60"
                      style={{
                        position: "absolute",
                        left: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        zIndex: 2,
                      }}
                    >
                      <line
                        x1="10"
                        y1="10"
                        x2="70"
                        y2="50"
                        stroke="#e53935"
                        strokeWidth="10"
                        strokeLinecap="round"
                        style={{ filter: "drop-shadow(0 2px 2px #fff)" }}
                      />
                      <line
                        x1="80"
                        y1="10"
                        x2="10"
                        y2="50"
                        stroke="#e53935"
                        strokeWidth="10"
                        strokeLinecap="round"
                        style={{ filter: "drop-shadow(0 2px 2px #fff)" }}
                      />
                    </svg> */}
                      <span className="discounted-price">
                        {pkg.discountedPrice}
                      </span>
                    </div>
                    <div className="">
                      {pkg.description && <p></p>}
                      <ul className="features-list h-50">
                        {pkg.features.map((feature, i) => (
                          <li key={i} className="feature-item">
                            <FontAwesomeIcon
                              icon={
                                feature.isAvailable
                                  ? faCheckCircle
                                  : faTimesCircle
                              }
                              className={`feature-icon ${
                                feature.isAvailable ? "" : "feature-icon-cross"
                              }`}
                            />{" "}
                            {feature.text}
                            {feature.link && (
                              <a
                                href="/doc/termsAndCondition.docx"
                                target="_blank"
                                className="feature-link"
                              >
                                - Terms & Conditions Apply
                              </a>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <button
                    className="buy-now-button"
                    onClick={() => handleConfirmPayment(pkg)}
                    disabled={loading[pkg.id]}
                  >
                    {loading[pkg.id] ? "Processing..." : "Buy Now"}
                  </button>
                  {error[pkg.id] && (
                    <p className="error-message">{error[pkg.id]}</p>
                  )}
                </div>
              ))
            ) : (
              <p></p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Packages;
